module.exports = __webpack_public_path__ + "img/no_video.baa4cdf8.svg";